import { listLink } from "../../ui/list-link";
import { DATE_EXAMPLE, DATE_REFUSED, dayOf } from "../../../server/rules/dates";
import { api, el, toast } from "../../ui/dom";
import { icon } from "../../ui/icons";
import { openModal } from "../../ui/modal";
import { openViewer } from "../../ui/viewer";
import { field, refuse, select } from "../clients/forms";

// File it (brief 1E-23, mockup v83 fileModal): every patient file is filed with What it is, and
// the kind decides where it shows (File to). Opened right after an upload and from the pencil on
// Documents. The kinds are the company's list (Home Care › Settings).

export interface FileKindChoice {
  id: string;
  name: string;
  code: string | null;
  fileTo: string;
}

/** Opens File it for one file. `done` runs once it's saved. */
export function fileItModal(
  file: { id: string; name: string; kindId?: string | null; datedOn?: string | null },
  kinds: readonly FileKindChoice[],
  done: () => void,
  preset?: string | null,
) {
  const start = file.kindId ?? kinds.find((k) => k.code === preset)?.id ?? "";
  const what = select(
    "What it is",
    [["", "Pick one"], ...kinds.map((k) => [k.id, k.name] as const)],
    start,
  );
  const to = field("File to", "", { readonly: "" });
  const dated = field("Date on the document", file.datedOn ?? "", {
    placeholder: "MM/DD/YYYY",
    inputmode: "numeric",
  });
  const fill = () => {
    to.input.value = kinds.find((k) => k.id === what.input.value)?.fileTo ?? "Documents";
  };
  what.input.addEventListener("change", fill);
  fill();
  const save = el("button", { type: "button", class: "btn pri" }, icon("check"), " Save");
  save.addEventListener("click", async () => {
    if (!what.input.value) return refuse(m.note, "Pick what it is.");
    if (dated.input.value.trim() && !dayOf(dated.input.value))
      return refuse(m.note, `${DATE_REFUSED}. ${DATE_EXAMPLE}`);
    save.disabled = true;
    const res = await api("PATCH", `/api/files/${file.id}/kind`, {
      kindId: what.input.value,
      datedOn: dated.input.value,
    });
    save.disabled = false;
    if (!res.ok) return refuse(m.note, res.body.error);
    m.close();
    toast(
      "Filed",
      `${kinds.find((k) => k.id === what.input.value)?.name ?? ""} · ${to.input.value}`,
    );
    done();
  });
  const m = openModal({
    title: "File it",
    sub: file.name,
    body: [
      el(
        "div",
        { class: "form", style: "max-width:none" },
        what.el,
        listLink("file_kind"),
        to.el,
        dated.el,
      ),
    ],
    actions: [save],
  });
  what.input.focus();
}

/** Files filed here by what they are (brief 1E-23): each opens in the viewer. */
export function filedHere(label: string, files: readonly { id: string; name: string }[]) {
  if (!files.length) return null;
  return el(
    "div",
    { class: "linkrow small", style: "margin:6px 0", "aria-label": label },
    el("span", { class: "muted" }, `${label}:`),
    ...files.map((f) => {
      const b = el(
        "button",
        { type: "button", class: "chip plain", "data-tip": "Open in the viewer" },
        icon("file"),
        ` ${f.name}`,
      );
      b.addEventListener("click", () => void openViewer({ file: f }));
      return b;
    }),
  );
}
